import { Button, HorizontalDivider, Image, Typography } from '@smartgift/frontend-toolkit';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ROUTE_PATHS } from '@hero/routes';

import InviteLayout from '../layout';

import * as S from './style';

export default function Page() {
  const { t } = useTranslation();

  return (
    <InviteLayout>
      <S.InviteExpired>
        <Image name="expiredGift" alt="Page Status Image" height={280} />

        <Typography variant="h3" color="var(--color-accent-primary-default)">
          {t('InviteExpired.title')}
        </Typography>

        <HorizontalDivider />

        <Typography variant="body2" color="fg" emphasis="weak" withBalancer>
          {t('InviteExpired.message')}
        </Typography>
        <Typography variant="body2" color="fg" emphasis="weak" withBalancer>
          {t('alreadyHaveAnAccount')}
          <Link to={ROUTE_PATHS.SIGN_IN}>
            <Button
              variant="link"
              color="fg"
              style={{ textTransform: 'inherit', display: 'inline-block', marginLeft: 4 }}
            >
              {t('signIn')}
            </Button>
          </Link>
        </Typography>
      </S.InviteExpired>
    </InviteLayout>
  );
}
